module.exports = __webpack_public_path__ + "img/fresadora2.fda10b33.png";